var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasStreamData)?[_c('router-view')]:[_c('NoSignalPage')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }